import { render } from "./PrivacyAndPolicy.vue?vue&type=template&id=79d11724&scoped=true"
import script from "./PrivacyAndPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyAndPolicy.vue?vue&type=script&lang=js"

import "./PrivacyAndPolicy.vue?vue&type=style&index=0&id=79d11724&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d11724"]])

export default __exports__